/* eslint-disable */
import { Typography } from 'components/Typography/Typography';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import {
  CircularProgress,
  IconButton,
  Stack,
  styled,
  TextField,
  Tooltip,
  tooltipClasses,
  TooltipProps
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

interface EditableLabelProps {
  value: string;
  onChange: (value: string) => void;
  loading?: boolean;
  onSave?: () => void;
  onCancel?: () => void;
  error?: string;
  isEditing: boolean;
  gridView?: boolean;
  setIsEditing: (isEditing: boolean) => void;
  fontSize?: number;
  inputError?: string | null;
  isRowEditing?: boolean;
  setIsRowEditing?: any;
  handletextClick?: any;
  style?: React.CSSProperties;
}

const ActionToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black
  }
}));

const StyledIconButton = styled(IconButton)({
  padding: '2px 2px 1px 0px',
  '& svg': {
    fontSize: '20px',
    fill: '#000'
  }
});

const EditableLabel: React.FC<EditableLabelProps> = ({
  value,
  onChange,
  onCancel,
  loading = false,
  error,
  isEditing,
  gridView,
  setIsEditing,
  onSave,
  fontSize,
  isRowEditing,
  setIsRowEditing,
  handletextClick,
  style,
  inputError,
}) => {
  // const displayValue = value.length > 8 ? `${value.slice(0, 8)}...` : value;
  const displayValue = value;

  return (
    <>
      {isEditing ? (
        <>
          <Stack direction="row" spacing={0}>
            <div className="flex flex-col gap-0 items-center justify-start">
              <input
                className="w-[14vw] text-[0.9vw] text-[#102633] bg-[#EDEDED] focus:outline-none rounded-sm h-7 mt-2.5 py-4 pl-3"
                value={value}
                onChange={(e: any) => onChange(e.target.value)}
                disabled={loading}
              />
            </div>
            <div
              style={
                !gridView ? { marginRight: !gridView ? '-3vw' : '' } : undefined
              }
            >
              <form
                onSubmit={onSave}
                style={
                  !gridView ? { marginLeft: !gridView ? '1vw' : '' } : undefined
                }
              >
                <Stack direction="row" spacing={1}>
                  {loading ? (
                    <CircularProgress
                      style={{
                        height: 15,
                        width: 15
                      }}
                    />
                  ) : (
                    <div className="flex items-center justify-center gap-2 pt-2.5">
                      <StyledIconButton size="medium" onClick={onCancel}>
                        <ActionToolTip title="Cancel">
                          <HighlightOffIcon />
                        </ActionToolTip>
                      </StyledIconButton>

                      <StyledIconButton size="medium" onClick={onSave}>
                        <ActionToolTip title="save">
                          <SaveOutlinedIcon />
                        </ActionToolTip>
                      </StyledIconButton>
                    </div>
                  )}
                </Stack>
              </form>
            </div>
          </Stack>
        </>
      ) : (
        <>
          <Stack direction={'row'} spacing={2} alignItems={'center'}>
            <p className="text-[#102633] text-[0.9vw] m-w-[20vw]" style={style} onClick={handletextClick} >
              {displayValue.length > 40
                ? `${displayValue.slice(0, 40)}...`
                : displayValue}
            </p>

            {isRowEditing ? (
              <FontAwesomeIcon
                icon={faEdit}
                style={{
                  opacity: 0.6,
                  cursor: 'not-allowed'
                }}
              />
            ) : (
              <ActionToolTip title="Edit">
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{
                    opacity: isRowEditing ? 0.6 : 1,
                    cursor: isRowEditing ? 'not-allowed' : 'pointer'
                  }}
                  onClick={() => {
                    if (!isRowEditing) {
                      setIsRowEditing(true);
                      setIsEditing(true);
                    }
                  }}
                />
              </ActionToolTip>
            )}
          </Stack>
        </>
      )}
    </>
  );
};
export default EditableLabel;
